<div layout="column" ui-view>
  <div layout="row" layout-align="space-around center" layout-padding>
    <form ng-submit="vm.applyFilters()" name="listFilters" layout="row" flex-gt-md="70" flex="100"
          layout-align="space-around center">
       <md-autocomplete flex="40" flex-gt-md="50" md-selected-item="vm.selectedTownHall"
                       md-search-text="vm.searchText"
                       md-items="townhall in vm.townhalls | filterAccents: vm.searchText"
                       md-item-text="townhall.name"
                       md-require-match
                       ng-required="true"
                       md-min-length="0"
                       ng-disabled="vm.townhalls.length === 1"
                       md-clear-button="true"
                       md-floating-label="{{'SELECT_TOWNHALL_TO_FILTER' | translate}}" style="padding-top: 15px">
        <md-item-template>
          <span md-highlight-text="vm.searchText" md-highlight-flags="^i">{{townhall.name}}</span>
        </md-item-template>
        <md-not-found>
          {{'RESULT_NOT_FOUND' | translate}}
        </md-not-found>
      </md-autocomplete>
      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.iniDate"
                     md-placeholder="{{'INI_DATE' | translate}}" md-min-date="vm.currentSeason.iniDate"
                     md-max-date="vm.endDate"></md-datepicker>
      <md-datepicker md-current-view="month" ng-required="true" ng-model="vm.endDate"
                     md-placeholder="{{'END_DATE' | translate}}" md-min-date="vm.iniDate"
                    ></md-datepicker>
      <md-button type="submit" ng-disabled="listFilters.$invalid" class="md-raised md-primary">{{'FILTER' |
        translate}}
      </md-button>
    </form>
  
  </div>
  <div layout="row" layout-align="space-around center" ng-if="vm.isFiltered">
    <md-card flex-gt-md="80" flex="100">

      <div class="md-whiteframe-1dp" flex>
        <md-card-header layout-padding>
          <md-card-header-text>
            <span class="md-headline">EQUIPS</span>
          </md-card-header-text>
        </md-card-header>
           <md-button ng-click="exportToExcel('table2', 'Report')">
                 <md-icon md-svg-src = '../../images/notebook.svg'></md-icon>
            </md-button> 
   <!--         <input type="file" id="fileInput" accept=".xls,.xlsx" onchange="angular.element(this).scope().loadExcel()" />
  -->
<style>
  .custom-file-input {
    display: none;
  }

  .custom-file-label {
    display: inline-block;
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    border-radius: 5px;
    text-align: center;
  }

  .custom-file-label:hover {
    background-color: #0056b3;
  }
</style>

<label for="fileInput" class="custom-file-label">Seleccionar Archivo .XLSX con los TG de playoff</label>

 <input type="file" id="fileInput" class="custom-file-input" accept=".xls,.xlsx" onchange="angular.element(this).scope().loadExcel()" />


      </div>
      <md-card-content>
        <span class="md-body-2" ng-if="vm.matches.length === 0">{{'CHAMPIONSHIPS.MATCHES_NOT_FOUND' | translate}}</span>
        <md-table-container ng-if="vm.matches.length > 0">
          <table md-table md-row-select="true" ng-model="vm.selected" md-progress="vm.promiseMatches" id="table2">
            <thead md-head md-order="vm.queryOrder" md-on-reorder="vm.reorder">
            <tr md-row>
              <th md-column md-order-by="town">ID</th>
              <th md-column md-order-by="championship">CAMPIONAT</th>
              <th md-column md-order-by="matchday">LOCAL</th>
              <th md-column md-order-by="date">VISITANT</th>
              <th md-column md-order-by="time">DATA</th>
              <th md-column md-order-by="localTeam">EMAIL_APP</th>
              <th md-column md-order-by="visitorTeam">EMAIL_PLAYOFF</th>
              <th md-column md-order-by="time">EQUIP AFECTAT</th>
    
              <th md-column md-order-by="facility">ES OK?</th>
       
              <th md-column >{{ 'ACTIONS' | translate}}</th>
      
            </tr>
            </thead>
            <tbody md-body>
            <tr md-row md-select="vm.select" ng-repeat="match in vm.matches">
              <td md-cell>{{match.idPartido}}</td>
              <td md-cell>{{match.campeonato}}</td>
              <td md-cell>{{match.equipoLocal}}</td>
              <td md-cell>{{match.equipoVisitante}}</td>
              <td md-cell>{{match.date}}</td>
              <td md-cell>{{match.emailapp}}</td>
              <td md-cell>{{match.emailplayoff}}</td>
              <td md-cell>{{match.equipoafectado}}</td>
        
               <td md-cell>{{match.isOK}}</td>
             
              <td md-cell>
                <md-button class="md-icon-button" 
                          ng-click="verpartido(match.idPartido)">
                  <md-tooltip md-direction="right" md-delay="50">{{'EDIT' | translate}}</md-tooltip>
                  <md-icon>edit</md-icon>
                </md-button>
              </td>
              
            </tr>
            </tbody>
          </table>
        </md-table-container>

      </md-card-content>
    </md-card>
  </div>
    
    
  
</div>

